
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusservicepuneairport() {



    const cardData =
    {
        keyword: 'Corporate Cab and Bus Services Pune Airport',
        heading: 'etravo : Corporate Cab and Bus Services Pune Airport ',
        headingDescription: 'eTravo provides reliable Corporate Cab and Bus Services to Pune Airport, ensuring seamless and timely airport transfers for executives, employees, and business guests. Whether it’s early morning departures, late-night arrivals, or scheduled pickups for corporate clients, our services are designed for punctuality, comfort, and professionalism. We offer a fleet of GPS-enabled cabs and spacious buses with trained chauffeurs to ensure hassle-free transfers to and from Pune Airport. Trust eTravo for dependable airport mobility solutions tailored to your business needs.',

        top: 'Top Places to Visit in Pune with etravo',
      "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Built in 1732, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire. Though much of the fort was destroyed by fire in 1828, the remaining structures, including the massive gates and foundations, offer a glimpse into its majestic past. The site is known for its architectural grandeur and the evening light and sound show that narrates its rich history."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Constructed in 1892, the Aga Khan Palace is a significant monument in Indian history. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi during the Quit India Movement. The palace is renowned for its Italian arches, sprawling lawns, and the memorials of Gandhi and Kasturba. It now houses a museum dedicated to Gandhi's life and work."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Perched atop a hill about 30 km from Pune, Sinhagad Fort is a popular trekking destination. The fort has witnessed several battles, including the famous Battle of Sinhagad in 1670. Visitors can explore the ruins, enjoy panoramic views of the surrounding region, and savor local delicacies like 'pithla bhakri' sold by vendors at the summit."
    },
    {
      "title": "Dagdusheth Halwai Ganapati Temple",
      "description": "This temple is one of the most famous Ganesh temples in India. Known for its rich history and the grand Ganesh Festival celebrations, the temple attracts thousands of devotees and tourists annually."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in Koregaon Park, the Osho International Meditation Resort is a tranquil haven for those seeking peace and spiritual growth. The ashram offers various meditation programs and workshops in a lush, serene environment."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses an extensive collection of over 20,000 artifacts, showcasing the everyday life of Indians in the past. From musical instruments and paintings to household items and sculptures, the museum offers a deep dive into India's rich cultural heritage."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "Dating back to the 8th century, the Pataleshwar Cave Temple is a rock-cut temple dedicated to Lord Shiva. Carved out of a single basalt rock, the temple features intricate carvings and a unique circular Nandi mandapa. It's a serene spot amidst the bustling city."
    },
    {
      "title": "Parvati Hill",
      "description": "Parvati Hill is one of the highest points in Pune, offering a panoramic view of the city. Atop the hill stands the Parvati Temple, dedicated to Goddess Parvati. The hill is a popular spot for morning walks and photography enthusiasts."
    },
    {
      "title": "Pune-Okayama Friendship Garden",
      "description": "Also known as Pu La Deshpande Garden, this is one of the largest Japanese-style gardens outside Japan. Inspired by the 300-year-old Okayama Korakuen Garden, it features manicured lawns, flowing streams, and picturesque bridges."
    },
    {
      "title": "Empress Garden",
      "description": "Spread over 39 acres, Empress Garden is a botanical garden known for its lush greenery, rare flora, and well-maintained lawns. It's a perfect spot for picnics, leisurely walks, and enjoying nature in the heart of the city."
    }
  ],
   "services": [
    {
      "name": "Pickup & Drop for Corporate Travelers at Pune Airport",
      "description": "eTravo offers seamless pickup and drop services specifically tailored for corporate travelers at Pune Airport. Our professional drivers and comfortable vehicles ensure timely airport transfers, helping busy executives and business guests reach their destinations without stress. With real-time flight tracking, we adjust pickup times to avoid any delays, providing a hassle-free travel experience."
    },
    {
      "name": "Business Cab Services from Pune Airport",
      "description": "Our business cab services from Pune Airport are designed to meet the needs of corporate clients who require prompt and efficient transport. Whether you need a single executive cab or multiple vehicles for a business group, eTravo provides a range of AC sedans and SUVs equipped with amenities suited for professional travel."
    },
    {
      "name": "Airport Transfer for Corporate Executives Pune",
      "description": "eTravo specializes in airport transfer services for corporate executives in Pune, offering luxury vehicles driven by experienced chauffeurs. We prioritize punctuality, privacy, and comfort, making sure executives arrive on time for meetings, conferences, or other engagements. Our airport transfers are customizable to fit your business schedule and travel preferences."
    },
    {
      "name": "AC Bus Rentals for Airport Pickup Pune",
      "description": "For corporate groups traveling through Pune Airport, eTravo provides air-conditioned bus rentals that guarantee comfort and convenience. Our fleet of well-maintained buses can accommodate varying group sizes and is ideal for transporting staff to hotels, offices, or event venues directly from the airport."
    },
    {
      "name": "Reliable Pune Airport Transport for Office Staff",
      "description": "eTravo’s reliable airport transport services ensure your office staff enjoy smooth transfers to and from Pune Airport. We offer scheduled pickups and drops that align with flight timings, keeping your workforce connected and on time. Our vehicles are sanitized regularly, and our drivers are trained to provide courteous, safe service."
    },
    {
      "name": "Corporate Group Transfers Pune Airport",
      "description": "Plan your corporate group transfers with ease using eTravo’s specialized services for Pune Airport. Whether it’s for conferences, seminars, or team outings, we provide coordinated transport solutions that handle multiple pickups and drop-offs efficiently. Our group transfer services are flexible, timely, and designed to simplify your corporate travel logistics."
    }
  ],
  "tableData": [
    ["Pickup & Drop for Corporate Travelers at Pune Airport", "Business Cab Services from Pune Airport"],
    ["Airport Transfer for Corporate Executives Pune", "AC Bus Rentals for Airport Pickup Pune"],
    ["Reliable Pune Airport Transport for Office Staff", "Corporate Group Transfers Pune Airport"]
  ],






"whychoose": [
    {
        "WhyChooseheading": "Seamless Corporate Airport Transfers in Pune",
        "WhyChoosedescription": "eTravo offers specialized cab and bus services for corporate airport transfers to and from Pune International Airport. Whether you're welcoming business guests, dropping off employees for flights, or scheduling round-trips for executives, our services are prompt, professional, and precisely timed."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles for Corporate Travel Needs",
        "WhyChoosedescription": "Choose from a fleet that includes luxury sedans, premium SUVs, and spacious AC buses for larger groups. Every vehicle is equipped with air conditioning, clean interiors, luggage space, and comfortable seating—perfect for airport pickups and drop-offs at any hour."
    },
    {
        "WhyChooseheading": "Real-Time Flight Tracking and Timely Pickups",
        "WhyChoosedescription": "We monitor flight schedules in real time to ensure timely pickups, even if flights are delayed or arrive early. Our chauffeurs coordinate closely with your admin or travel team, eliminating wait times and ensuring a smooth arrival or departure experience from Pune Airport."
    },
    {
        "WhyChooseheading": "Professional Drivers with Airport Protocol Experience",
        "WhyChoosedescription": "Our drivers are trained to handle corporate airport transfers with utmost professionalism. They are courteous, punctual, and familiar with Pune Airport’s procedures and entry points, ensuring a seamless experience for your clients, staff, and executives."
    },
    {
        "WhyChooseheading": "Custom Travel Plans for Group or VIP Airport Transfers",
        "WhyChoosedescription": "Whether it's a single executive pickup or bulk staff transfers to the airport for conferences or client visits, we offer flexible plans that scale to your needs. Our corporate packages cover everything from one-time trips to ongoing contracts for frequent flyers."
    },
    {
        "WhyChooseheading": "Transparent Pricing and Easy Corporate Billing",
        "WhyChoosedescription": "Enjoy clear pricing with no surge charges or last-minute add-ons. eTravo provides GST-compliant invoices, monthly billing, and ride summaries—making it easy for your accounts and admin departments to track travel expenses and ensure audit-ready records."
    },
    {
        "WhyChooseheading": "24/7 Availability for Early and Late Flights",
        "WhyChoosedescription": "We operate around the clock to accommodate red-eye flights, early departures, and late-night arrivals. Our team is available 24/7 to adjust bookings, provide updates, or handle emergencies—so you’re never left stranded at Pune Airport."
    },
    {
        "WhyChooseheading": "Technology-Driven Ride Management",
        "WhyChoosedescription": "With our mobile app and web dashboard, your travel managers can schedule, track, and modify airport transfers in real time. Receive automatic driver and vehicle details, live tracking, and instant updates to ensure complete visibility and control over each trip."
    }
]

































    }

// Corporate Cab and Bus Services Pune Airport – eTravo

const faqData = [
    [
        {
            question: 'What kind of corporate transport does eTravo offer at Pune Airport?',
            answer: 'eTravo offers professional cab and bus services for corporate clients at Pune Airport, including executive pickups, team transfers, group transport, and scheduled airport shuttles.',
        },
        {
            question: 'Can eTravo manage bulk airport pickups and drops for corporate events or teams?',
            answer: 'Yes, we specialize in coordinating group transport for events, trainings, and team movements. Our fleet of cabs, tempo travellers, and AC buses can handle bulk transfers with ease.',
        },
        {
            question: 'What types of vehicles are available for corporate airport travel in Pune?',
            answer: 'Our fleet includes premium sedans, hatchbacks, SUVs, tempo travellers, and AC buses ranging from 13 to 50 seats — suitable for executives, small teams, or large delegations.',
        },
        {
            question: 'Does eTravo offer meet-and-greet or assisted pickup services at Pune Airport?',
            answer: 'Yes, we provide meet-and-greet options for VIP and international guests, with placard services, luggage assistance, and trained chauffeurs to ensure a professional experience.',
        },
        {
            question: 'Can your team handle early morning and late-night airport schedules?',
            answer: 'Absolutely. We operate 24/7 to align with all flight timings. Our team ensures timely dispatch and tracking so your employees or guests never face delays.',
        },
        {
            question: 'Is there a dedicated support team for managing airport transport logistics?',
            answer: 'Yes, every corporate client gets a dedicated account manager to handle scheduling, tracking, updates, and communication for seamless airport transfer experiences.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Kunal Joshi',
        designation: 'Travel Desk Lead, Orion Global',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo is our go-to for airport transport in Pune. Their team is highly organized, and we’ve never had issues with delays or last-minute changes — even with large groups.”',
    },
    {
        name: 'Ms. Sneha Rao',
        designation: 'Admin Executive, NexaTech India',
        rating: [1, 1, 1, 1, 1],
        text: '“Whether it’s 3 AM or 3 PM, eTravo has always been punctual. Their Pune Airport cab and bus services are reliable and ideal for handling our frequent corporate travel needs.”',
    },
];












    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services Pune Airport",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-pune-airport.jpg",
  "description": "Reliable corporate cab and bus services at Pune Airport by eTravo. Perfect for business traveler pickups, corporate group transfers, and airport transport for executives and office staff with AC vehicles.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2350"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-pune-airport"
  }
};





    return (
        <div>

<Helmet>
  <title>Corporate Cab and Bus Services Pune Airport | Executive Pickup & Drop | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services at Pune Airport with eTravo for business travelers, executive pickups, and group transfers. Reliable AC vehicles and timely airport transport." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/20.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusservicepuneairport;